import "regenerator-runtime/runtime";
import _asyncToGenerator from "/data/landun/workspace/b-1ce38705e8d749ebacb1574ceae41f8a/codebase/pages/jueji/node_modules/@vue/cli-plugin-babel/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _objectSpread from "/data/landun/workspace/b-1ce38705e8d749ebacb1574ceae41f8a/codebase/pages/jueji/node_modules/@vue/cli-plugin-babel/node_modules/@babel/runtime/helpers/esm/objectSpread2";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import GamePop from '../Pop/GamePop/GamePop';
import { mapState, mapActions } from 'vuex';
import MagicService from '@/service/magic';
export default {
  components: {
    GamePop: GamePop
  },
  data: function data() {
    return {
      showLotteryRes: false,
      // 是否展示抽奖结果弹窗
      lotteryResOptions: null,
      // 抽奖结果信息
      lotterying: false // 是否正在抽奖

    };
  },
  computed: _objectSpread({}, mapState(['remainNum'])),
  methods: _objectSpread(_objectSpread({}, mapActions(['refreshLotteryInfo'])), {}, {
    // 抽奖前置判断
    doLottery: function doLottery() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (_this.loginService.isLogin) {
                  _context.next = 3;
                  break;
                }

                _this.$openLogin();

                return _context.abrupt("return");

              case 3:
                if (_this.remainNum) {
                  _context.next = 6;
                  break;
                }

                _this.eventBus.$emit('showPayPop');

                return _context.abrupt("return");

              case 6:
                if (!_this.lotterying) {
                  _context.next = 8;
                  break;
                }

                return _context.abrupt("return");

              case 8:
                // 开始抽奖
                _this.lotterying = true;
                _context.prev = 9;
                _context.next = 12;
                return _this.lottery();

              case 12:
                _context.next = 17;
                break;

              case 14:
                _context.prev = 14;
                _context.t0 = _context["catch"](9);
                _this.lotterying = false;

              case 17:
                _this.lotterying = false;

              case 18:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[9, 14]]);
      }))();
    },
    // 执行抽奖
    lottery: function lottery() {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var 互动抽奖ID, res, ret, data, code, msg;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                互动抽奖ID = _this2.setting.魔方配置.互动抽奖ID;
                _context2.next = 4;
                return MagicService.lottery({
                  module_id: 互动抽奖ID
                });

              case 4:
                res = _context2.sent;
                ret = +res.ret;
                data = res.data;
                code = +data.sys_code;

                if (ret === 0) {
                  _this2.refreshLotteryInfo();

                  if (code === 0) {
                    // todo 显示奖品弹窗
                    _this2.showLottery({
                      pic: data.lottery_url,
                      name: data.lottery_name,
                      type: 1
                    });
                  } else if (code === -100) {
                    // todo 显示未中奖的信息
                    _this2.showLottery({
                      pic: 'https://vfiles.gtimg.cn/vupload/20201109/aebbf81604900376023.png'
                    });
                  } else {
                    _this2.toast(data.lottery_txt);
                  }
                } else if (ret === -905) {
                  // 未通过安全策略
                  _this2.shieldRun(res.security_verify, function () {
                    _this2.lottery();
                  });
                } else {
                  _this2.toast(data.lottery_txt);
                }

                _context2.next = 15;
                break;

              case 11:
                _context2.prev = 11;
                _context2.t0 = _context2["catch"](0);
                msg = _context2.t0.message || _context2.t0.msg || "\u7CFB\u7EDF\u5F00\u5C0F\u5DEE\u4E86\uFF0C\u8BF7\u7A0D\u540E\u91CD\u8BD5(".concat(_context2.t0.code, ")");

                _this2.toast(msg);

              case 15:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, null, [[0, 11]]);
      }))();
    },
    // 展示抽奖结果
    showLottery: function showLottery(options) {
      this.lotteryResOptions = options;
      this.showLotteryRes = true;
    }
  })
};